import createCachedSelector from "re-reselect";
import * as actions from "../allocateResponsible/actionCreator";

const ids = (filters, page, pageSize, state) => {
  const key = actions.loadResponsibleFoldersKey(filters, pageSize);
  const responsibleChangeFolders = state.responsibleChangeFolders.list[key];
  const result = responsibleChangeFolders[page] ? responsibleChangeFolders[page].ids : [];

  return result;
};

const responsibleChangeFolders = (filters, page, pageSize, state) =>
  state.entities.responsibleChangeFolders ? state.entities.responsibleChangeFolders : [];

export const getResponsibleFoldersCached = createCachedSelector(
  ids,
  responsibleChangeFolders,
  (ids, responsibleChangeFolders) => ids.map(id => responsibleChangeFolders[id])
)((filters, page, pageSize) => actions.loadResponsibleFoldersKey(filters, pageSize));

export const getResponsibleFolders = (filters, page, pageSize, state) => {
  const key = actions.loadResponsibleFoldersKey(filters, pageSize);
  const responsibleChangeFolders = state.responsibleChangeFolders.list[key];

  const loading =
    responsibleChangeFolders && responsibleChangeFolders[page] ? responsibleChangeFolders[page].loading : false;
  const loaded =
    responsibleChangeFolders && responsibleChangeFolders[page] ? responsibleChangeFolders[page].loaded : false;
  const totalCount =
    responsibleChangeFolders && responsibleChangeFolders.totalCount ? responsibleChangeFolders.totalCount : 0;
  const content = loaded ? getResponsibleFoldersCached(filters, page, pageSize, state) : [];

  return { loading, loaded, content, totalCount };
};
